import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { ActionMenuOption, MENU_ALIGNMENTS, MENU_DIRECTIONS } from 'ui/actionMenu/types';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { FolderClosed, Hide24, View24 } from 'ui/icons';
import { TipPlacement, Tooltip } from 'ui/tooltip';

const Flex = styled.div`
  display: inline-flex;
  & > div button {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  & > span button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    margin-left: -1px;

    & [data-combo-button-overflow] {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
`;

type CampaignFolderMenuProps = {
  hideFolders: boolean;
  onClick: () => void;
  options: ActionMenuOption[];
};

export const CampaignFolderMenu = ({ hideFolders, onClick, options }: CampaignFolderMenuProps) => {
  return (
    <Flex>
      <ActionMenu
        align={MENU_ALIGNMENTS.RIGHT}
        direction={MENU_DIRECTIONS.BOTTOM}
        options={options}
      >
        <Button id="folder-options" variant={BUTTON_VARIANTS.SECONDARY} size={BUTTON_SIZES.LARGE}>
          <FolderClosed />
          <span>Folders</span>
        </Button>
      </ActionMenu>

      <Tooltip
        tooltipContent={hideFolders ? 'Show folders' : 'Hide folders'}
        placement={TipPlacement.Bottom}
      >
        <IconButton
          id="hide-folders"
          variant={BUTTON_VARIANTS.SECONDARY}
          size={BUTTON_SIZES.LARGE}
          onClick={onClick}
        >
          {hideFolders ? <Hide24 data-test="hide-icon" /> : <View24 data-test="view-icon" />}
        </IconButton>
      </Tooltip>
    </Flex>
  );
};
